export const ACTION_TAG = 'data-report'; // 上报埋点
export const ACTION_GLOBAL_TAG = 'data-report-global'; // 上报全局埋点
export const ACTION_EXTRA_TAG = 'data-report-extra'; // 上报额外信息

export const ACTION_HOTTAG_TAG = 'data-report-hottag'; // 可视化热点节点
export const ACTION_HOTTSG_STYLE = 'data-report-style'; // 热点样式

export const ACTION_HOTTAG_CLASS = 'dsh-hottag'; // 可视化热点蒙层
export const ACTION_HOTTAG_COUNT_CLASS = 'dsh-hottag-count'; // 可视化热点数据

export const DEFAULT_REPORT_EXCLUDE = ['.data-report-hub-panel', '.data-report-hub-drawer'];
export const DEFAULT_REPORT_NODE = ['A', 'BUTTON'];

export const PAGE_VIEW_ACTION = 'page-view';

export const SHORTCUTS_CONFIG = [
  { startRelativeDate: 0, endRelativeDate: 0, label: '今天' },
  { startRelativeDate: -1, endRelativeDate: -1, label: '昨天' },
  { startRelativeDate: -6, endRelativeDate: 0, label: '最近7天' },
  { startRelativeMonth: 0, endRelativeMonth: 0, label: '本月' },
  { startRelativeDate: -29, endRelativeDate: 0, label: '最近30天' },
];
